module.exports = __webpack_public_path__ + "media/larry.32012035.wav";